import Cookies from "js-cookie";
import { contractAddress } from "../config";
import { blockchainNetworks } from "../config/blockchain";
import { drawTicketApi, fetchDrawList } from "./ApiService";
export const fetchUserTickets = async () => {
  try {
    const address = Cookies.get("connectedAddress");
    if (!address) {
      throw new Error("User address not found in cookies.");
    }

    const drawDataList = [];
    const drawList = await fetchDrawList();
    const apiResponse = await drawTicketApi(address);

    if (apiResponse && apiResponse.data) {
      apiResponse.data.forEach((element) => {
        const currentDraw = drawList.data.find(
          (item) => item.drawId === element.drawId
        );

        const drawData = {
          id: element.drawId,
          name: element?.drawName ?? "",
          drawId: element.drawId,
          drawCode: `${element.drawName}_${element.drawId}`,
          ticketNumber: "",
          startDate: element?.startTime ?? "",
          endDate: element?.endTime ?? "",
          poolPrize: currentDraw?.rewardPoolPrize ?? "0",
          winProbability: currentDraw?.winningProbability ?? "",
          ticketData: [],
          currencyTicker: currentDraw?.currencyTicker ?? "",
        };

        const blockchainData = blockchainNetworks[currentDraw.blockchain];

        element.tickets.map((ticket) => {
          drawData.ticketData.push({
            drawId: element.drawId,
            ticketNumber: ticket.ticketNumber,
            NFTNumber: ticket.nftTokenId,
            tokenURI: `${blockchainData.explorerBaseUrl}/nft/${contractAddress}/${ticket.nftTokenId}`,
            purchaseDate: ticket.purchaseDate,
            ticketPrice: ticket.ticketPrice,
            currencyTicker: currentDraw?.currencyTicker || "",
            nftExplorerUrl: `${blockchainData.explorerBaseUrl}/nft/${contractAddress}/${ticket.nftTokenId}`,
            transactionHashUrl: `${blockchainData.explorerBaseUrl}/tx/${ticket.transactionHash}`,
            transactionHash: ticket.transactionHash || "",
            blockchain: currentDraw.blockchain,
          });
        });
        drawDataList.push(drawData);
      });
      return drawDataList;
    }
  } catch (error) {
    console.error("Error fetching user tickets:", error);
    return [];
  }
};
